import moment from 'moment';
import { API_URL } from '../config/config';
import { getRequest } from '../utils/axiosUtils';

const BASE = `${API_URL}/admin/email-tracking`;

// Email-tracking endpoints take a few params the shared buildQueryParams does
// not know about (eventType, template, delivered), so build the query here.
const buildEmailQuery = ({
  dateRange,
  campaign,
  template,
  eventType,
  delivered,
  search,
  page,
  limit,
} = {}) => {
  const params = new URLSearchParams();
  const startDate = dateRange?.startDate ? moment(dateRange.startDate) : null;
  const endDate = dateRange?.endDate ? moment(dateRange.endDate) : null;
  if (startDate && endDate) {
    params.set('startDate', startDate.format('YYYY-MM-DD'));
    params.set('endDate', endDate.format('YYYY-MM-DD'));
  }
  if (campaign) params.set('campaign', campaign);
  if (template) params.set('template', template);
  if (eventType) params.set('eventType', eventType);
  if (delivered === 'true' || delivered === 'false') params.set('delivered', delivered);
  if (search) params.set('search', search);
  if (page) params.set('page', page);
  if (limit) params.set('limit', limit);
  return params.toString();
};

export const fetchEmailSummary = async (filter) => {
  const res = await getRequest({ url: `${BASE}/summary?${buildEmailQuery(filter)}` });
  if (!res) return null;
  if (res.status >= 200 && res.status < 300) return res.data.data;
  throw new Error(`Unexpected response code: ${res.status}`);
};

export const fetchEmailTimeseries = async (filter) => {
  const res = await getRequest({ url: `${BASE}/timeseries?${buildEmailQuery(filter)}` });
  if (!res) return [];
  if (res.status >= 200 && res.status < 300) return res.data.data;
  throw new Error(`Unexpected response code: ${res.status}`);
};

export const fetchEmailEvents = async (filter) => {
  const res = await getRequest({ url: `${BASE}/events?${buildEmailQuery(filter)}` });
  if (!res) return null;
  if (res.status >= 200 && res.status < 300) return res.data.data;
  throw new Error(`Unexpected response code: ${res.status}`);
};
